// Generated by scripts/optimize-images.py — do not edit by hand.
export const images = {
  "hero-thriving": {
    "width": 1408,
    "height": 768,
    "widths": [
      480,
      768,
      1152,
      1408
    ],
    "hash": "46567e85"
  },
  "longevity-gap": {
    "width": 896,
    "height": 1280,
    "widths": [
      400,
      640,
      896
    ],
    "hash": "9413bcd0"
  },
  "donate-band": {
    "width": 1408,
    "height": 768,
    "widths": [
      640,
      1024,
      1408
    ],
    "hash": "884d646b"
  },
  "logo-horizontal": {
    "width": 1800,
    "height": 544,
    "widths": [
      400,
      800
    ],
    "hash": "2f0f8b09"
  },
  "team-luis-gallegos": {
    "width": 928,
    "height": 928,
    "widths": [
      128,
      256
    ],
    "hash": "6687bb74"
  },
  "team-silvia-candamil-neira": {
    "width": 602,
    "height": 602,
    "widths": [
      128,
      256
    ],
    "hash": "9691f9ec"
  },
  "team-kirsten-suto-seckler": {
    "width": 888,
    "height": 888,
    "widths": [
      128,
      256
    ],
    "hash": "694cd586"
  },
  "team-alison-bryant": {
    "width": 382,
    "height": 382,
    "widths": [
      128,
      256
    ],
    "hash": "91c0e2a1"
  },
  "team-david-evangelista": {
    "width": 994,
    "height": 994,
    "widths": [
      128,
      256
    ],
    "hash": "ab56d79f"
  },
  "media-report-2025": {
    "width": 1200,
    "height": 800,
    "widths": [
      400,
      800
    ],
    "hash": "082a30a0"
  },
  "media-podcast-4ql": {
    "width": 800,
    "height": 600,
    "widths": [
      400,
      800
    ],
    "hash": "63308bd7"
  },
  "pfrpa-logo": {
    "width": 600,
    "height": 569,
    "widths": [
      160,
      320
    ],
    "hash": "001fbec6"
  }
} as const

export type ImageName = keyof typeof images
